var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Button, Field, FieldType } from '../../../elements';
import { Validation } from '../../../helpers/Validation';
import { store as mainStore } from '../../../App';
import { t, T } from '../../../helpers/i18n';
import { mapValues, objectValues } from '../../../helpers/Utils';
import History, { toParentPath } from '../../../helpers/History';
import { ButtonsBar } from '../../../Styles';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from '../../../Theme';
var MoneysForm = /** @class */ (function (_super) {
    __extends(MoneysForm, _super);
    function MoneysForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            values: {}
        };
        _this.isCreate = function () {
            return !!!_this.props.match.params.id;
        };
        _this.isCustomed = function () {
            var _a;
            return (_a = _this.props.money) === null || _a === void 0 ? void 0 : _a.customed;
        };
        _this.isEditable = function () {
            return _this.isCreate() || _this.isCustomed();
        };
        _this.fieldAlpahbeticCode = {
            name: 'alphabeticCode',
            type: _this.isEditable() ? FieldType.Text : FieldType.Label,
            // rules: rules(),
            size: 4
        };
        _this.fieldNumericCode = {
            name: 'numericCode',
            type: _this.isEditable() ? FieldType.Text : FieldType.Label,
            // rules: rules(),
            size: 4
        };
        _this.fieldCurrency = {
            name: 'currency',
            type: _this.isEditable() ? FieldType.Text : FieldType.Label,
            // rules: rules(),
            size: 4
        };
        _this.fieldMinorUnit = {
            name: 'minorUnit',
            type: _this.isEditable() ? FieldType.Text : FieldType.Label,
            // rules: rules(),
            size: 4
        };
        _this.fields = [
            _this.fieldAlpahbeticCode,
            _this.fieldNumericCode,
            _this.fieldCurrency,
            _this.fieldMinorUnit,
            {
                name: 'primary',
                type: FieldType.Checkbox,
                // rules: rules(),
                size: 4
            },
            /*{
              name: 'secondary',
              type: FieldType.Checkbox,
              // rules: rules(),
              size: 4
            },
            {
              name: 'web',
              type: FieldType.Checkbox,
              // rules: rules(),
              size: 4
            },*/
        ];
        _this.handleChange = function (name, value, column) {
            // si es web o primary secondary tiene que deshabilitarse
            // si es secondary
            if ((name === 'primary' || column === 'primary')) {
                // no puede estar secondary
                if (value && _this.state.values.secondary) {
                    var accept = confirm("va a cambiar una moneda secundaria por ".concat(column ? column : name, ", \u00BFdesea continuar?"));
                    if (accept) {
                        _this.setState(function (prevState) {
                            var _a;
                            return ({ values: __assign(__assign({}, prevState.values), (_a = {}, _a[column ? column : name] = value, _a.secondary = false, _a)) });
                        });
                        return;
                    }
                }
                else if (!value) {
                    var accept = confirm("vas a quitar la moneda de ".concat(column ? column : name, ", si continua tiene que seleccionar otra como ").concat(column ? column : name));
                    if (!accept) {
                        return;
                    }
                }
            }
            else if ((name === 'secondary' || column === 'secondary') && value) {
                // no puede estar primary ni web
                if (_this.state.values.primary || _this.state.values.secondary) {
                    var accept = confirm("va a cambiar una moneda como ".concat(_this.state.values.primary ? t('primary') : '', " a ").concat(t(column ? column : name)));
                    if (accept) {
                        _this.setState(function (prevState) {
                            var _a;
                            return ({ values: __assign(__assign({}, prevState.values), (_a = {}, _a[column ? column : name] = value, _a.primary = false, _a)) });
                        });
                        return;
                    }
                }
            }
            _this.setState(function (prevState) {
                var _a;
                return ({ values: __assign(__assign({}, prevState.values), (_a = {}, _a[column ? column : name] = value, _a)) });
            });
        };
        _this.handleCancel = function () {
            toParentPath();
        };
        _this.handleDisable = function (disable) {
            var money = _this.props.money;
            var store = _this.props.store.moneysStore;
            var accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (store && store.disable && money) {
                    store.disable(money.id, disable).then(toParentPath);
                }
            }
        };
        _this.handleReset = function () {
            _this.setState({ values: _this.parsedValues() });
        };
        _this.handleSubmit = function () {
            var values = __assign({}, _this.state.values);
            console.log('handleSubmit - values: ', values);
            console.log('handleSubmit - schema: ', _this.schema);
            var propsValues = _this.props.money;
            var store = _this.props.store.moneysStore;
            var validation = new Validation(values, _this.schema);
            console.log('handleSubmit - validation: ', validation);
            if (validation.valid) {
                // Remove unmodified value
                _this.fields.map(function (field) {
                    if (propsValues && values[field.column ? field.column : field.name] === propsValues[field.column ? field.column : field.name]) {
                        delete values[field.column ? field.column : field.name];
                    }
                });
                if (Object.keys(values).length === 0)
                    return mainStore.UI.newWarning(T('nothingModified'));
                // Convert empty strings to null
                // console.log('antes de mapValues - values', values)
                values = mapValues(values, function (value) { return (value === '' ? null : value); });
                // console.log('mapValues - values', values)
                // Use FormData instead of JSON if there is a image in value
                var data_1;
                if (Object.keys(_this.schema).includes('image')) {
                    // console.log('handleSubmit - image')
                    data_1 = new FormData();
                    Object.keys(values).forEach(function (key) {
                        if (values[key])
                            data_1.append(key, values[key]);
                    });
                }
                else {
                    data_1 = values;
                }
                console.log('handleSubmit - data', data_1);
                if (store && data_1) {
                    var request = void 0;
                    if (propsValues) {
                        request = store.update(propsValues.id, data_1);
                    }
                    else {
                        request = store.create(data_1);
                    }
                    request.then(toParentPath);
                }
                else {
                    mainStore.UI.newWarning('error indefinido');
                }
            }
            else {
                mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
                // console.log('handleSubmit - !validation.valid - validation.errors', validation.errors)
            }
        };
        _this.schema = _this.fields.reduce(function (previous, field) {
            previous[field.column ? field.column : field.name] = field.rules;
            return previous;
        }, {});
        return _this;
    }
    MoneysForm.prototype.componentDidMount = function () {
        this.setState({ values: this.parsedValues() });
    };
    MoneysForm.prototype.render = function () {
        var _this = this;
        var money = this.props.money;
        var moneysStore = this.props.store.moneysStore;
        // console.log('money: ', money)
        var values = this.state.values;
        var canBeDisabled = 'disabled' in (money || {}) || 'disabled_at' in (money || {});
        var disabled = canBeDisabled && (money.disabled_at != null);
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('values: ', values)
        return (React.createElement(Wrapper, null,
            this.fields.map(function (field) { return (React.createElement(Field, { key: field.column ? field.column : field.name, field: __assign(__assign({}, field), { value: values[field.column ? field.column : field.name] === 0 ? '0' : values[field.column ? field.column : field.name] || '' }), onChange: _this.handleChange })); }),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('cancel'))),
                money && canBeDisabled ? (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: function () { return _this.handleDisable(false); } }, t('enable'))) : (React.createElement(StyledButton, { onClick: function () { return _this.handleDisable(true); } }, t('disable')))) /*: canBeDeleted ? (
                  <StyledButton onClick={this.handleDelete}>
                    {t('delete')}
                  </StyledButton>
                )*/
                    : null,
                React.createElement(StyledButton, { onClick: this.handleReset }, t('reset')),
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    };
    MoneysForm.prototype.parsedValues = function (props) {
        if (props === void 0) { props = this.props; }
        // console.log('props.values: ', props.values)
        var values = props.money || {};
        // console.log('values: ', values)
        // console.log('parsedValues - values', values)
        var result = this.fields.reduce(function (fields, field) {
            var _a;
            // console.log('field.column', field.column)
            var indice = field.column ? field.column : field.name;
            // console.log('indice', indice)
            // console.log('values[indice]', values[indice])
            return __assign(__assign({}, fields), (_a = {}, _a[indice] = values[indice]
                ||
                    (field.type === FieldType.Select
                        ? (field.placeholder
                            ? null
                            : field.options && field.options[0] && field.options[0].value)
                        : field.type === FieldType.Date ? new Date() : values[indice]), _a));
        }, {});
        // console.log('parsedValues - result', result)
        return result;
    };
    MoneysForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ? props.store.moneysStore.read(+props.match.params.id).then(function (money) { return ({ money: money }); }) : undefined
        ]; }),
        observer
    ], MoneysForm);
    return MoneysForm;
}(Component));
export default MoneysForm;
var Wrapper = cxs('div')((_a = {
        paddingBottom: Theme.size.bar
    },
    _a[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        // paddingBottom: 0
    },
    _a));
var StyledButton = cxs(Button)(function (_a) {
    var _b;
    var isDisabled = _a.isDisabled;
    return (_b = {
            color: isDisabled ? Theme.color.primary : 'inherit'
        },
        _b[mediaQueries.desktop] = {
            padding: Theme.size.space[2]
        },
        _b);
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Moneys/containers/MoneysForm.tsx
// module id = 1613
// module chunks = 0